import React from 'react';
import { useState,useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import {createProvider} from '../../../../../../../../crud/management_api/providers';
import {getCategoriesOptions} from '../../../Table/components/utils/functions';
import './CreateProvider.scss';

  

const CreateProvider: React.FC<any> = ({
    showCreateModal,
    setShowCreateModal,
    setCurrentData,
    currentData
  }) => {
    const [categorias_providers, setCategoriasProviders] = useState<any[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);

    useEffect(() => {
      getCategoriesOptions().then((response) => {
            if (response) {
              setCategoriasProviders(response);
            }
        });
        }, []);

    const handleToggleCategory = (categoryId: number) => {
      setSelectedCategories(prev => {
        if (prev.includes(categoryId)) {
          return prev.filter(id => id !== categoryId);
        } else {
          return [...prev, categoryId];
        }
      });
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      if (!form) {
        console.error('Form not found.');
        return;
      }

      // Validación de campos obligatorios
      const requiredFields = [
        { key: 'provider_name', label: 'Nombre' }
      ];
      const missingFields = requiredFields.filter(field => {
        const value = form[field.key]?.value;
        return !value || value.trim() === '';
      });
      if (missingFields.length > 0) {
        const missingLabels = missingFields.map(f => f.label).join(', ');
        toast.error(`Por favor completa los siguientes campos: ${missingLabels}`);
        return;
      }

      const userContext = localStorage.getItem('user');
      const companyId = userContext != null ? JSON.parse(userContext).company_id : 0;
      const create_Provider: any = {
        company_id: companyId,
        name: form.provider_name.value,
        number: form.number.value || null,
        email: form.email.value || null,
        numero_tributario: form.numero_tributario.value || null,
        category_ids: selectedCategories
      };
      
      createProvider(create_Provider)
        .then((response: any) => {
          toast.success('Proveedor creado con éxito!');
          setShowCreateModal(false);
          setCurrentData([response.data, ...currentData]);
          // Reset form
          setSelectedCategories([]);
        })
        .catch(error => {
          console.error('Error al crear un proveedor:', error);
          toast.error(error.response?.data?.message || 'Error al crear un proveedor');
        });

  };

    return (
        <Modal className="create-provider-modal" show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Form onSubmit={handleFormSubmit}>
            <Modal.Header>
            <div className='form-modal-title-container'>
              <Modal.Title className='form-modal-title'>Crear proveedor</Modal.Title>
            </div>
              <Button variant="none" className="modal-close-button" onClick={() => setShowCreateModal(false)}>
                <X size={24} />
              </Button>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="provider_name" className='mp-formgroup'>
                <Form.Label>Nombre</Form.Label>
                <Form.Control type="text" name="name" placeholder="Nombre del proveedor" required />
              </Form.Group>

              <Form.Group controlId="email" className='mp-formgroup'>
                <Form.Label>Correo electrónico</Form.Label>
                <Form.Control type="email" name="email" placeholder="correo@ejemplo.com" />
              </Form.Group>

              <div className="horizontal-fields-row">
                <Form.Group controlId="number" className='mp-formgroup'>
                  <Form.Label>Número</Form.Label>
                  <Form.Control type="text" name="number" placeholder="+1-555-0123" />
                </Form.Group>
                <Form.Group controlId="numero_tributario" className='mp-formgroup'>
                  <Form.Label>Número Tributario</Form.Label>
                  <Form.Control type="text" name="numero_tributario" placeholder="12-3456789" />
                </Form.Group>
              </div>

              <Form.Group className='mp-formgroup category-selection-group'>
                <Form.Label>Categorías</Form.Label>
                {(!categorias_providers || categorias_providers.length === 0) ? (
                  <div className="no-categories-warning">
                    Debe crear al menos una categoría de proveedor antes de asignar categorías.
                  </div>
                ) : (
                  <div className="category-badges-container">
                    {categorias_providers.map((category) => (
                      <button
                        key={category.id}
                        type="button"
                        className={`category-badge-button ${selectedCategories.includes(category.id) ? 'selected' : ''}`}
                        onClick={() => handleToggleCategory(category.id)}
                      >
                        {category.name}
                      </button>
                    ))}
                  </div>
                )}
                {selectedCategories.length === 0 && (
                  <small className="text-muted">Selecciona al menos una categoría (opcional)</small>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
            <div className="form-modal-footer-custom">
              <Button className="form-button-cancel" onClick={() => setShowCreateModal(false)}>Cancelar</Button>
              <Button className="form-button-create" type="submit">Crear proveedor</Button>
            </div>
            </Modal.Footer>
          </Form>
        </Modal>
      );
  };

export default CreateProvider;


